var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('ScrollupSection'),_c('div',{staticClass:"all-area"},[(!_vm.isEmbed)?_c('HeaderSection'):_vm._e(),_c('PrivacyPolicySection'),(!_vm.isEmbed)?_c('FooterSection'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }